import React, { useState } from 'react';
import './policy.css';
import Footer from '../../components/Footer/Footer';
import data from './Policies.json';
import CircleIcon from '@mui/icons-material/Circle';
import { Fade } from 'react-reveal';

const Policy = () => {

  return (
    <>
      <div className='policy'>
        <div className='policy-container'>
          <div className="policy-header-flex">
            <div className='policy-main-header'>Privacy Policy</div>
            <a href ="./assets/Qevolt Privacy Policy.docx" download = "Qevolt Privacy Policy" target="_blank" className="policy-download">
              <div className="policy-download-text">
                Download
              </div>
              <div className="policy-download-image">
                <img src="./assets/policydl.svg" alt="" />
              </div>
            </a>
          </div>
          
          <div className='policy-mainText'>
            <div className='top-mainText'>
              Qevolt respects your privacy and is committed to protecting your
              personal data. This privacy policy will inform you as to how we
              look after your personal data when you visit our website
              (regardless of where you visit it from) and tell you about your
              privacy rights and how the law protects you.
            </div>
            <div className='bottom-mainText'>
              This privacy policy is provided in a layered format so you can
              click through to the specific areas set out below. Please also use
              the Glossary to understand the meaning of some of the terms used
              in this privacy policy.
            </div>
          </div>
          <div className='policy-links'>
            <a href = "#policy-one" className='policy-link'>
              1.
              <span
                className='policy-link-color policy-one'
                
              >
                Important information and who we are
              </span>
            </a>
            <a href = "#policy-two" className='policy-link'>
              2.
              <span className='policy-link-color' >
                The Data we Collect about you
              </span>
            </a>
            <a href = "#policy-three" className='policy-link'>
              3.
              <span className='policy-link-color' >
                How is your Personal Data Collected?
              </span>
            </a>
            <a href = "#policy-four" className='policy-link'>
              4.
              <span className='policy-link-color' >
                How we use your Personal Data
              </span>
            </a>
            <a href = "#policy-five"className='policy-link'>
              5.
              <span className='policy-link-color' >
                Disclosure of your Personal Data
              </span>
            </a>
            <a href = "#policy-six" className='policy-link'>
              6.
              <span className='policy-link-color' >
                International Transfers
              </span>
            </a>
            <a href = "#policy-seven" className='policy-link'>
              7.
              <span className='policy-link-color' >
                Data Security
              </span>
            </a>
            <a href = "#policy-eight" className='policy-link'>
              8.
              <span className='policy-link-color' >
                Data Retention
              </span>
            </a>
            <a href = "#policy-nine" className='policy-link'>
              9.
              <span className='policy-link-color' >
                Your Legal Rights
              </span>
            </a>
            <a href = "#policy-ten" className='policy-link'>
              10.
              <span className='policy-link-color' >
                Glossary
              </span>
            </a>
          </div>
          <div className='policy-content'>
           
              <Fade>
                <div className='content-header' id = "policy-one">
                  1. Important information and who we are
                </div>
                <div className='content-boldText'>
                  PURPOSE OF THIS PRIVACY POLICY
                </div>
                <div className='content-normalText'>
                  This privacy policy aims to give you information on how Qevolt
                  collects and processes your personal data through your use of
                  this website, including any data you may provide through this
                  website when you use our service, put up an event for ticket
                  sales or purchase a ticket.<br></br> This website is not
                  intended for children and we do not knowingly collect data
                  relating to children. It is important that you read this
                  privacy policy together with any other privacy policy or fair
                  processing policy we may provide on specific occasions when we
                  are collecting or processing personal data about you so that
                  you are fully aware of how and why we are using your data.
                  This privacy policy supplements other notices and privacy
                  policies and is not intended to override them.
                </div>
                <div className='content-boldText'>CONTROLLER </div>
                <div className='content-normalText'>
                  Qevolt events is the controller and responsible for your
                  personal data (collectively referred to as “Qevolt”, “we”,
                  “us” or “our” in this privacy policy). We have appointed a
                  data privacy manager who is responsible for overseeing
                  questions in relation to this privacy policy. If you have any
                  questions about this privacy policy, including any requests to
                  exercise your legal rights, please contact the data privacy
                  manager using the details set out below.
                </div>
                <div className='content-boldText'>CONTACT DETAILS</div>
                <div className='content-normalText'>
                  If you have any questions about this privacy policy or our
                  privacy practices, please contact our data privacy manager in
                  the following ways:<br></br> Full name of legal entity: Qevolt
                  Limited<br></br> Email address:{' '}
                  <span className='purple'>dataprivacy@qevolt.com</span>
                  <br></br> You have the right to make a complaint at any time
                  to the National Information Technology Development Agency, the
                  Nigerian regulator for data protection issues (
                  <a
                    className='purple'
                    href='https://nitda.gov.ng/'
                    target='_blank'
                  >
                    https://nitda.gov.ng/
                  </a>
                  ). We would, however, appreciate the chance to deal with your
                  concerns before you approach the NITDA so please contact us in
                  the first instance.
                </div>
                <div className='content-boldText'>
                  CHANGES TO THE PRIVACY POLICY AND YOUR DUTY TO INFORM US OF
                  CHANGES
                </div>
                <div className='content-normalText'>
                  We keep our privacy policy under regular review. This version
                  was last updated on 11 th November, 2022. It is important that
                  the personal data we hold about you is accurate and current.
                  Please keep us informed if your personal data changes during
                  your relationship with us.
                </div>
                <div className='content-boldText'>THIRD-PARTY LINKS </div>
                <div className='content-normalText'>
                  This website may include links to third-party websites,
                  plug-ins and applications. Clicking on those links or enabling
                  those connections may allow third parties to collect or share
                  data about you. We do not control these third-party websites
                  and are not responsible for their privacy statements. When you
                  leave our website, we encourage you to read the privacy policy
                  of every website you visit.
                </div>

                <div className='content-header' id = "policy-two">
                  2. The Data we Collect about you
                </div>
                <div className='content-normalText mt-s'>
                  Personal data, or personal information, means any information
                  about an individual from which that person can be identified.
                  It does not include data where the identity has been removed
                  (anonymous data).<br></br>
                </div>
                <div className='content-normalText mt-s'>
                  We may collect, use, store and transfer different kinds of
                  personal data about you which we have grouped together as
                  follows:<br></br>
                </div>
                <div className='content-normalText mt-l'>
                  <CircleIcon
                    className='circleIcon'
                    sx={{ fontSize: '.3rem' }}
                  />
                  Identity Data includes first name, maiden name, last name,
                  username or similar identifier, marital status, title, date of
                  birth and gender.
                </div>
                <div className='content-normalText mt-l'>
                  <CircleIcon
                    className='circleIcon'
                    sx={{ fontSize: '.3rem' }}
                  />
                  Contact Data includes billing address, delivery address, email
                  address and telephone numbers.
                </div>
                <div className='content-normalText mt-l'>
                  <CircleIcon
                    className='circleIcon'
                    sx={{ fontSize: '.3rem' }}
                  />
                  Financial Data includes bank account and payment card details.
                </div>
                <div className='content-normalText mt-l'>
                  <CircleIcon
                    className='circleIcon'
                    sx={{ fontSize: '.3rem' }}
                  />
                  Transaction Data includes details about payments to and from
                  you and other details of products and services you have
                  purchased from us.
                </div>
                <div className='content-normalText mt-l'>
                  <CircleIcon
                    className='circleIcon'
                    sx={{ fontSize: '.3rem' }}
                  />
                  Technical Data includes internet protocol (IP) address, your
                  login data, browser type and version, time zone setting and
                  location, browser plug-in types and versions, operating system
                  and platform, and other technology on the devices you use to
                  access this website.
                </div>
                <div className='content-normalText mt-l'>
                  <CircleIcon
                    className='circleIcon'
                    sx={{ fontSize: '.3rem' }}
                  />
                  Profile Data includes your username and password, purchases or
                  orders made by you, your interests, preferences, feedback and
                  survey responses.
                </div>
                <div className='content-normalText mt-l'>
                  <CircleIcon
                    className='circleIcon'
                    sx={{ fontSize: '.3rem' }}
                  />
                  Usage Data includes information about how you use our website,
                  products and services.
                </div>
                <div className='content-normalText mt-l'>
                  <CircleIcon
                    className='circleIcon'
                    sx={{ fontSize: '.3rem' }}
                  />
                  Marketing and Communications Data includes your preferences in
                  receiving marketing from us and our third parties and your
                  communication preferences.
                </div>
                <div className='content-normalText mt-s'>
                  We also collect, use and share Aggregated Data such as
                  statistical or demographic data for any purpose. Aggregated
                  Data could be derived from your personal data but is not
                  considered personal data in law as this data will not directly
                  or indirectly reveal your identity. For example, we may
                  aggregate your Usage Data to calculate the percentage of users
                  accessing a specific website feature. However, if we combine
                  or connect Aggregated Data with your personal data so that it
                  can directly or indirectly identify you, we treat the combined
                  data as personal data which will be used in accordance with
                  this privacy policy.
                </div>
                <div className='content-normalText mt-s'>
                  We do not collect any Special Categories of Personal Data
                  about you (this includes details about your race or ethnicity,
                  religious or philosophical beliefs, sex life, sexual
                  orientation, political opinions, trade union membership,
                  information about your health, and genetic and biometric
                  data). Nor do we collect any information about criminal
                  convictions and offences.
                </div>
                <div className='content-boldText'>
                  IF YOU FAIL TO PROVIDE PERSONAL DATA
                </div>
                <div className='content-normalText'>
                  Where we need to collect personal data by law, or under the
                  terms of a contract we have with you, and you fail to provide
                  that data when requested, we may not be able to perform the
                  contract we have or are trying to enter into with you (for
                  example, to provide you with goods or services). In this case,
                  we may have to cancel a product or service you have with us
                  but we will notify you if this is the case at the time.
                </div>
                <div className='content-header' id = "policy-three">
                  3. How is your Personal Data Collected?
                </div>
                <div className='content-normalText mt-s'>
                  We use different methods to collect data from and about you
                  including through:
                </div>
                <div className='content-normalText mt-l'>
                  <CircleIcon
                    className='circleIcon'
                    sx={{ fontSize: '.3rem' }}
                  />
                  Direct interactions. You may give us your Identity, Contact
                  and Financial Data by filling in forms or by corresponding
                  with us by post, phone, email or otherwise. This includes
                  personal data you provide when you{' '}
                </div>
                <div className='content-normalText mt-l ml-i'>
                  <CircleIcon
                    className='circleIcon'
                    sx={{ fontSize: '.3rem' }}
                  />
                  apply for our products or services;
                </div>
                <div className='content-normalText mt-l ml-i'>
                  <CircleIcon
                    className='circleIcon'
                    sx={{ fontSize: '.3rem' }}
                  />
                  create an account on our website;
                </div>
                <div className='content-normalText mt-l ml-i'>
                  <CircleIcon
                    className='circleIcon'
                    sx={{ fontSize: '.3rem' }}
                  />
                  subscribe to our service or publications;
                </div>
                <div className='content-normalText mt-l ml-i'>
                  <CircleIcon
                    className='circleIcon'
                    sx={{ fontSize: '.3rem' }}
                  />
                  request marketing to be sent to you;
                </div>
                <div className='content-normalText mt-l ml-i'>
                  <CircleIcon
                    className='circleIcon'
                    sx={{ fontSize: '.3rem' }}
                  />
                  enter a competition, promotion or survey; or
                </div>
                <div className='content-normalText mt-l ml-i'>
                  <CircleIcon
                    className='circleIcon'
                    sx={{ fontSize: '.3rem' }}
                  />
                  give us feedback or contact us.
                </div>
                <div className='content-normalText mt-l'>
                  <CircleIcon
                    className='circleIcon'
                    sx={{ fontSize: '.3rem' }}
                  />
                  Automated technologies or interactions. As you interact with
                  our website, we will automatically collect Technical Data
                  about your equipment, browsing actions and patterns. We
                  collect this personal data by using cookies, server logs and
                  other similar technologies. Please see our{' '}
                  <a className='purple'>cookie policy</a> for further details.
                </div>
                <div className='content-normalText mt-l'>
                  <CircleIcon
                    className='circleIcon'
                    sx={{ fontSize: '.3rem' }}
                  />
                  Third parties or publicly available sources. We will receive
                  personal data about you from various third as set out below:
                  Technical Data from the following parties:
                </div>
                <div className='content-normalText mt-l ml-i'>
                  <CircleIcon
                    className='circleIcon'
                    sx={{ fontSize: '.3rem' }}
                  />
                  analytics providers such as Google
                </div>
                <div className='content-normalText mt-l ml-i'>
                  <CircleIcon
                    className='circleIcon'
                    sx={{ fontSize: '.3rem' }}
                  />
                  advertising networks
                </div>
                <div className='content-normalText mt-l ml-i'>
                  <CircleIcon
                    className='circleIcon'
                    sx={{ fontSize: '.3rem' }}
                  />
                  identity verification service providers; and
                </div>
                <div className='content-normalText mt-l ml-i'>
                  <CircleIcon
                    className='circleIcon'
                    sx={{ fontSize: '.3rem' }}
                  />
                  search information providers
                </div>
                <div className='content-normalText mt-l'>
                  <CircleIcon
                    className='circleIcon'
                    sx={{ fontSize: '.3rem' }}
                  />
                  Contact, Financial and Transaction Data from providers of
                  technical, payment and delivery services.
                </div>
                <div className='content-normalText mt-l'>
                  <CircleIcon
                    className='circleIcon'
                    sx={{ fontSize: '.3rem' }}
                  />
                  Identity and Contact Data from data brokers or aggregators.
                </div>
                <div className='content-normalText mt-l'>
                  <CircleIcon
                    className='circleIcon'
                    sx={{ fontSize: '.3rem' }}
                  />
                  Identity and Contact Data from publicly available sources such
                  as Corporate Affairs Commission, and the Independent National
                  Electoral Commission.
                </div>

                <div className='content-header' id = "policy-four">
                  4. How we use your Personal Data
                </div>
                <div className='content-normalText mt-s'>
                  We will only use your personal data when the law allows us to.
                  Most commonly, we will use your personal data in the following
                  circumstances:
                </div>
                <div className='content-normalText mt-l'>
                  <CircleIcon
                    className='circleIcon'
                    sx={{ fontSize: '.3rem' }}
                  />
                  Where we need to perform the contract we are about to enter
                  into or have entered into with you.
                </div>
                <div className='content-normalText mt-l'>
                  <CircleIcon
                    className='circleIcon'
                    sx={{ fontSize: '.3rem' }}
                  />
                  Where it is necessary for our legitimate interests (or those
                  of a third party) and your interests and fundamental rights do
                  not override those interests.
                </div>
                <div className='content-normalText mt-l'>
                  <CircleIcon
                    className='circleIcon'
                    sx={{ fontSize: '.3rem' }}
                  />
                  Where we need to comply with a legal obligation.
                </div>
                <div className='content-normalText mt-s'>
                  Click{' '}
                  <span
                    className='purple'
                    
                    style={{ cursor: 'pointer' }}
                  >
                    lawful bias
                  </span>{' '}
                  to find out more about the types of lawful basis that we will
                  rely on to process your personal data.
                </div>
                <div className='content-normalText'>
                  Generally, we do not rely on consent as a legal basis for
                  processing your personal data although we will get your
                  consent before sending third party direct marketing
                  communications to you via email or text message. You have the
                  right to withdraw consent to marketing at any time by
                  contacting us.
                </div>
                <div className='content-boldText'>
                  PURPOSES FOR WHICH WE WILL USE YOUR PERSONAL DATA
                </div>
                <div className='content-normalText'>
                  We have set out below, in a table format, a description of all
                  the ways we plan to use your personal data, and which of the
                  legal bases we rely on to do so. We have also identified what
                  our legitimate interests are where appropriate. Note that we
                  may process your personal data for more than one lawful ground
                  depending on the specific purpose for which we are using your
                  data. Please contact us if you need details about the specific
                  legal ground we are relying on to process your personal data
                  where more than one ground has been set out in the table
                  below.
                </div>
                <div className='content-normalText'>
                  <table className='mt-s'>
                    <tr>
                      <th>Purpose/Activity</th>
                      <th>Type of data</th>
                      <th>
                        Lawful basis for processing including basis of
                        legitimate interest
                      </th>
                    </tr>
                    <tr>
                      <td>To register you as a new customer</td>
                      <td>
                        <CircleIcon
                          className='circleIcon'
                          sx={{ fontSize: '.3rem' }}
                        />
                        Identity<br></br>
                        <CircleIcon
                          className='circleIcon'
                          sx={{ fontSize: '.3rem' }}
                        />
                        Contact
                      </td>
                      <td>Performance of a contract with you</td>
                    </tr>
                    <tr>
                      <td>
                        To process and deliver your order including:<br></br>
                        <CircleIcon
                          className='circleIcon'
                          sx={{ fontSize: '.3rem' }}
                        />
                        Manage payments, fees and charges<br></br>
                        <CircleIcon
                          className='circleIcon'
                          sx={{ fontSize: '.3rem' }}
                        />
                        Collect and recover money owed to us
                      </td>
                      <td>
                        <CircleIcon
                          className='circleIcon'
                          sx={{ fontSize: '.3rem' }}
                        />
                        Identity<br></br>
                        <CircleIcon
                          className='circleIcon'
                          sx={{ fontSize: '.3rem' }}
                        />
                        Contact<br></br>
                        <CircleIcon
                          className='circleIcon'
                          sx={{ fontSize: '.3rem' }}
                        />
                        Financial<br></br>
                        <CircleIcon
                          className='circleIcon'
                          sx={{ fontSize: '.3rem' }}
                        />
                        Transaction<br></br>
                        <CircleIcon
                          className='circleIcon'
                          sx={{ fontSize: '.3rem' }}
                        />
                        Marketing and Communications
                        <br></br>
                      </td>
                      <td>
                        <CircleIcon
                          className='circleIcon'
                          sx={{ fontSize: '.3rem' }}
                        />
                        Performance of a contract with you
                        <br></br>
                        <CircleIcon
                          className='circleIcon'
                          sx={{ fontSize: '.3rem' }}
                        />
                        Necessary for our legitimate interests (to recover debts
                        due to us)
                        <br></br>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        To manage our relationship with you which will include:
                        <br></br>
                        <CircleIcon
                          className='circleIcon'
                          sx={{ fontSize: '.3rem' }}
                        />
                        Notifying you about changes to our terms or privacy
                        policy
                        <br></br>
                        <CircleIcon
                          className='circleIcon'
                          sx={{ fontSize: '.3rem' }}
                        />
                        Asking you to leave a review or take a survey
                        <br></br>
                      </td>
                      <td>
                        <CircleIcon
                          className='circleIcon'
                          sx={{ fontSize: '.3rem' }}
                        />
                        Identity
                        <br></br>
                        <CircleIcon
                          className='circleIcon'
                          sx={{ fontSize: '.3rem' }}
                        />
                        Contact
                        <br></br>
                        <CircleIcon
                          className='circleIcon'
                          sx={{ fontSize: '.3rem' }}
                        />
                        Profile
                        <br></br>
                        <CircleIcon
                          className='circleIcon'
                          sx={{ fontSize: '.3rem' }}
                        />
                        Marketing and Communications
                        <br></br>
                      </td>
                      <td>
                        <CircleIcon
                          className='circleIcon'
                          sx={{ fontSize: '.3rem' }}
                        />
                        Performance of a contract with you
                        <br></br>
                        <CircleIcon
                          className='circleIcon'
                          sx={{ fontSize: '.3rem' }}
                        />
                        Necessary to comply with a legal obligation
                        <br></br>
                        <CircleIcon
                          className='circleIcon'
                          sx={{ fontSize: '.3rem' }}
                        />
                        Necessary for our legitimate interests (to keep our
                        records updated and to study how customers use our
                        products/services)
                        <br></br>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        To enable you to partake in a prize draw, competition or
                        complete a survey
                      </td>
                      <td>
                        <CircleIcon
                          className='circleIcon'
                          sx={{ fontSize: '.3rem' }}
                        />
                        Identity
                        <br></br>
                        <CircleIcon
                          className='circleIcon'
                          sx={{ fontSize: '.3rem' }}
                        />
                        Contact
                        <br></br>
                        <CircleIcon
                          className='circleIcon'
                          sx={{ fontSize: '.3rem' }}
                        />
                        Profile
                        <br></br>
                        <CircleIcon
                          className='circleIcon'
                          sx={{ fontSize: '.3rem' }}
                        />
                        Usage
                        <br></br>
                        <CircleIcon
                          className='circleIcon'
                          sx={{ fontSize: '.3rem' }}
                        />
                        Marketing and Communications
                        <br></br>
                      </td>
                      <td>
                        <CircleIcon
                          className='circleIcon'
                          sx={{ fontSize: '.3rem' }}
                        />
                        Performance of a contract with you
                        <br></br>
                        <CircleIcon
                          className='circleIcon'
                          sx={{ fontSize: '.3rem' }}
                        />
                        Necessary for our legitimate interests (to study how
                        customers use our products/services, to develop them and
                        grow our business)
                        <br></br>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        To administer and protect our business and this website
                        (including troubleshooting, data analysis, testing,
                        system maintenance, support, reporting and hosting of
                        data)
                      </td>
                      <td>
                        <CircleIcon
                          className='circleIcon'
                          sx={{ fontSize: '.3rem' }}
                        />
                        Identity
                        <br></br>
                        <CircleIcon
                          className='circleIcon'
                          sx={{ fontSize: '.3rem' }}
                        />
                        Contact
                        <br></br>
                        <CircleIcon
                          className='circleIcon'
                          sx={{ fontSize: '.3rem' }}
                        />
                        Technical
                        <br></br>
                      </td>
                      <td>
                        <CircleIcon
                          className='circleIcon'
                          sx={{ fontSize: '.3rem' }}
                        />
                        Necessary for our legitimate interests (for running our
                        business, provision of administration and IT services,
                        network security, to prevent fraud and in the context of
                        a business reorganisation or group restructuring
                        exercise)
                        <br></br>
                        <CircleIcon
                          className='circleIcon'
                          sx={{ fontSize: '.3rem' }}
                        />
                        Necessary to comply with a legal obligation
                        <br></br>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        To deliver relevant website content and advertisements
                        to you and measure or understand the effectiveness of
                        the advertising we serve to you
                      </td>
                      <td>
                        <CircleIcon
                          className='circleIcon'
                          sx={{ fontSize: '.3rem' }}
                        />
                        Identity
                        <br></br>
                        <CircleIcon
                          className='circleIcon'
                          sx={{ fontSize: '.3rem' }}
                        />
                        Contact
                        <br></br>
                        <CircleIcon
                          className='circleIcon'
                          sx={{ fontSize: '.3rem' }}
                        />
                        Profile
                        <br></br>
                        <CircleIcon
                          className='circleIcon'
                          sx={{ fontSize: '.3rem' }}
                        />
                        Usage
                        <br></br>
                        <CircleIcon
                          className='circleIcon'
                          sx={{ fontSize: '.3rem' }}
                        />
                        Marketing and Communications
                        <br></br>
                        <CircleIcon
                          className='circleIcon'
                          sx={{ fontSize: '.3rem' }}
                        />
                        Technical
                        <br></br>
                      </td>
                      <td>
                        Necessary for our legitimate interests (to study how
                        customers use our products/services, to develop them, to
                        grow our business and to inform our marketing strategy)
                      </td>
                    </tr>
                    <tr>
                      <td>
                        To use data analytics to improve our website,
                        products/services, marketing, customer relationships and
                        experiences
                      </td>
                      <td>
                        <CircleIcon
                          className='circleIcon'
                          sx={{ fontSize: '.3rem' }}
                        />
                        Technical
                        <br></br>
                        <CircleIcon
                          className='circleIcon'
                          sx={{ fontSize: '.3rem' }}
                        />
                        Usage
                        <br></br>
                      </td>
                      <td>
                        Necessary for our legitimate interests (to define types
                        of customers for our products and services, to keep our
                        website updated and relevant, to develop our business
                        and to inform our marketing strategy)
                      </td>
                    </tr>
                    <tr>
                      <td>
                        To make suggestions and recommendations to you about
                        goods or services that may be of interest to you
                      </td>
                      <td>
                        <CircleIcon
                          className='circleIcon'
                          sx={{ fontSize: '.3rem' }}
                        />
                        Identity
                        <br></br>
                        <CircleIcon
                          className='circleIcon'
                          sx={{ fontSize: '.3rem' }}
                        />
                        Contact
                        <br></br>
                        <CircleIcon
                          className='circleIcon'
                          sx={{ fontSize: '.3rem' }}
                        />
                        Technical
                        <br></br>
                        <CircleIcon
                          className='circleIcon'
                          sx={{ fontSize: '.3rem' }}
                        />
                        Usage
                        <br></br>
                        <CircleIcon
                          className='circleIcon'
                          sx={{ fontSize: '.3rem' }}
                        />
                        Profile
                        <br></br>
                        <CircleIcon
                          className='circleIcon'
                          sx={{ fontSize: '.3rem' }}
                        />
                        Marketing and Communications
                        <br></br>
                      </td>
                      <td>
                        Necessary for our legitimate interests (to develop our
                        products/services and grow our business)
                      </td>
                    </tr>
                  </table>
                  <div className='content-boldText'>MARKETING</div>
                  <div className='content-normalText'>
                    We strive to provide you with choices regarding certain
                    personal data uses, particularly around marketing and
                    advertising. We have established the following personal data
                    control mechanisms:
                  </div>
                  <div className='content-boldText'>
                    PROMOTIONAL OFFERS FROM US
                  </div>
                  <div className='content-normalText'>
                    We may use your Identity, Contact, Technical, Usage and
                    Profile Data to form a view on what we think you may want or
                    need, or what may be of interest to you. This is how we
                    decide which products, services and offers may be relevant
                    for you (we call this marketing).
                    <br></br>
                    You will receive marketing communications from us if you
                    have requested information from us or purchased goods or
                    services from us and you have not opted out of receiving
                    that marketing.
                  </div>
                </div>
                <div className='content-boldText'>THIRD-PARTY MARKETING </div>
                <div className='content-normalText'>
                  We will get your express opt-in consent before we share your
                  personal data with any third party for marketing purposes.
                </div>
                <div className='content-boldText'>OPTING OUT</div>
                <div className='content-normalText'>
                  You can ask us or third parties to stop sending you marketing
                  messages at any time by following the opt-out links on any
                  marketing message sent to you.<br></br>
                  Where you opt out of receiving these marketing messages, this
                  will not apply to personal data provided to us as a result of
                  a product/service purchase, warranty registration,
                  product/service experience or other transactions.
                </div>
                <div className='content-boldText'>COOKIES</div>
                <div className='content-normalText'>
                  You can set your browser to refuse all or some browser
                  cookies, or to alert you when websites set or access cookies.
                  If you disable or refuse cookies, please note that some or all
                  parts of this website may become inaccessible or not function
                  properly. For more information about the cookies we use,
                  please see <a className='purple'>cookie policy</a>
                </div>
                <div className='content-boldText'>CHANGE OF PURPOSE</div>
                <div className='content-normalText'>
                  We will only use your personal data for the purposes for which
                  we collected it, unless we reasonably consider that we need to
                  use it for another reason and that reason is compatible with
                  the original purpose. If you wish to get an explanation as to
                  how the processing for the new purpose is compatible with the
                  original purpose, please contact us.
                  <br></br>
                  If we need to use your personal data for an unrelated purpose,
                  we will notify you and we will explain the legal basis which
                  allows us to do so.
                  <br></br>
                  Please note that we may process your personal data without
                  your knowledge or consent, in compliance with the above rules,
                  where this is required or permitted by law.
                </div>

                <div className='content-header' id = "policy-five">
                  5. Disclosure of your Personal Data
                </div>
                <div className='content-normalText mt-s'>
                  We may share your personal data with the parties set out below
                  for the purposes set out in the table Purposes for which we
                  will use your personal data above.
                </div>
                <div className='content-normalText mt-l'>
                  <CircleIcon
                    className='circleIcon'
                    sx={{ fontSize: '.3rem' }}
                  />
                  Internal Third Parties as set out in the{' '}
                  <span
                    className='purple'
                    
                    style={{ cursor: 'pointer' }}
                  >
                    {' '}
                    Glossary
                  </span>
                </div>
                <div className='content-normalText mt-l'>
                  <CircleIcon
                    className='circleIcon'
                    sx={{ fontSize: '.3rem' }}
                  />
                  External Third Parties as set out in the
                  <span
                    className='purple'
                    
                    style={{ cursor: 'pointer' }}
                  >
                    {' '}
                    Glossary
                  </span>
                </div>
                <div className='content-normalText mt-l'>
                  <CircleIcon
                    className='circleIcon'
                    sx={{ fontSize: '.3rem' }}
                  />
                  Specific third parties listed in the table Purposes for which
                  we will use your personal data above.
                </div>
                <div className='content-normalText mt-l'>
                  <CircleIcon
                    className='circleIcon'
                    sx={{ fontSize: '.3rem' }}
                  />
                  Third parties to whom we may choose to sell, transfer or merge
                  parts of our business or our assets. Alternatively, we may
                  seek to acquire other businesses or merge with them. If a
                  change happens to our business, then the new owners may use
                  your personal data in the same way as set out in this privacy
                  policy.
                </div>
                <div className='content-normalText mt-s'>
                  We require all third parties to respect the security of your
                  personal data and to treat it in accordance with the law. We
                  do not allow our third-party service providers to use your
                  personal data for their own purposes and only permit them to
                  process your personal data for specified purposes and in
                  accordance with our instructions.
                </div>

                <div className='content-header' id = "policy-six">6. International Transfers</div>
                <div className='content-normalText mt-s'>
                  Many of our external third parties are based outside the
                  Nigeria so their processing of your personal data will involve
                  a transfer of data outside Nigeria.
                </div>
                <div className='content-normalText'>
                  Whenever we transfer your personal data out of, we ensure a
                  similar degree of protection is afforded to it by ensuring at
                  least one of the following safeguards is implemented:
                </div>
                <div className='content-normalText mt-l'>
                  <CircleIcon
                    className='circleIcon'
                    sx={{ fontSize: '.3rem' }}
                  />
                  We will only transfer your personal data to countries that
                  have been deemed to provide an adequate level of protection
                  for personal data.
                </div>

                <div className='content-header' id = "policy-seven">7. Data Security</div>
                <div className='content-normalText mt-s'>
                  We have put in place appropriate security measures to prevent
                  your personal data from being accidentally lost, used or
                  accessed in an unauthorised way, altered or disclosed. In
                  addition, we limit access to your personal data to those
                  employees, agents, contractors and other third parties who
                  have a business need to know. They will only process your
                  personal data on our instructions and they are subject to a
                  duty of confidentiality. We have put in place procedures to
                  deal with any suspected personal data breach and will notify
                  you and any applicable regulator of a breach where we are
                  legally required to do so.
                </div>

                <div className='content-header' id = "policy-eight">8. Data Retention</div>
                <div className='content-boldText'>
                  HOW LONG WILL YOU USE MY PERSONAL DATA FOR?
                </div>
                <div className='content-normalText'>
                  We will only retain your personal data for as long as
                  reasonably necessary to fulfil the purposes we collected it
                  for, including for the purposes of satisfying any legal,
                  regulatory, tax, accounting or reporting requirements. We may
                  retain your personal data for a longer period in the event of
                  a complaint or if we reasonably believe there is a prospect of
                  litigation in respect to our relationship with you.
                  <br></br>
                  To determine the appropriate retention period for personal
                  data, we consider the amount, nature and sensitivity of the
                  personal data, the potential risk of harm from unauthorised
                  use or disclosure of your personal data, the purposes for
                  which we process your personal data and whether we can achieve
                  those purposes through other means, and the applicable legal,
                  regulatory, tax, accounting or other requirements.
                </div>
                <div className='content-normalText'>
                  In some circumstances you can ask us to delete your data: see{' '}
                  <span
                    className='purple'
                    
                    style={{ cursor: 'pointer' }}
                  >
                    your legal rights
                  </span>{' '}
                  for further information.
                </div>

                <div className='content-header' id = "policy-nine">9. Your Legal Rights</div>
                <div className='content-normalText mt-s'>
                  Under certain circumstances, you have rights under data
                  protection laws in relation to your personal data. Please
                  click on the links below to find out more about these rights:
                </div>
                <div className='content-normalText mt-l'>
                  <CircleIcon
                    className='circleIcon'
                    sx={{ fontSize: '.3rem' }}
                  />
                  Request access to your personal data.
                </div>

                <div className='content-normalText mt-l'>
                  <CircleIcon
                    className='circleIcon'
                    sx={{ fontSize: '.3rem' }}
                  />
                  Request erasure of your personal data.
                </div>
                <div className='content-normalText mt-l'>
                  <CircleIcon
                    className='circleIcon'
                    sx={{ fontSize: '.3rem' }}
                  />
                  Object to processing of your personal data.
                </div>
                <div className='content-normalText mt-l'>
                  <CircleIcon
                    className='circleIcon'
                    sx={{ fontSize: '.3rem' }}
                  />
                  Request restriction of processing your personal data.
                </div>
                <div className='content-normalText mt-l'>
                  <CircleIcon
                    className='circleIcon'
                    sx={{ fontSize: '.3rem' }}
                  />
                  Request transfer of your personal data.
                </div>
                <div className='content-normalText mt-l'>
                  <CircleIcon
                    className='circleIcon'
                    sx={{ fontSize: '.3rem' }}
                  />
                  Right to withdraw consent.
                </div>
                <div className='content-normalText mt-s'>
                  If you wish to exercise any of the rights set out above,
                  please contact us.
                </div>
                <div className='content-boldText'>NO FEE USUALLY REQUIRED</div>
                <div className='content-normalText'>
                  You will not have to pay a fee to access your personal data
                  (or to exercise any of the other rights). However, we may
                  charge a reasonable fee if your request is clearly unfounded,
                  repetitive or excessive. Alternatively, we could refuse to
                  comply with your request in these circumstances.
                </div>
                <div className='content-boldText'>
                  WHAT WE MAY NEED FROM YOU{' '}
                </div>
                <div className='content-normalText'>
                  We may need to request specific information from you to help
                  us confirm your identity and ensure your right to access your
                  personal data (or to exercise any of your other rights). This
                  is a security measure to ensure that personal data is not
                  disclosed to any person who has no right to receive it. We may
                  also contact you to ask you for further information in
                  relation to your request to speed up our response.
                </div>
                <div className='content-boldText'>TIME LIMIT TO RESPOND</div>
                <div className='content-normalText'>
                  We try to respond to all legitimate requests within one month.
                  Occasionally it could take us longer than a month if your
                  request is particularly complex or you have made a number of
                  requests. In this case, we will notify you and keep you
                  updated.
                </div>

                <div className='content-header' id = "policy-ten">10. Glossary</div>
                <div className='content-boldText'>LAWFUL BASIS </div>
                <div className='content-normalText'>
                  Legitimate Interest means the interest of our business in
                  conducting and managing our business to enable us to give you
                  the best service/product and the best and most secure
                  experience. We make sure we consider and balance any potential
                  impact on you (both positive and negative) and your rights
                  before we process your personal data for our legitimate
                  interests. We do not use your personal data for activities
                  where our interests are overridden by the impact on you
                  (unless we have your consent or are otherwise required or
                  permitted to by law). You can obtain further information about
                  how we assess our legitimate interests against any potential
                  impact on you in respect of specific activities by contacting
                  us.
                  <br></br>
                  Performance of Contract means processing your data where it is
                  necessary for the performance of a contract to which you are a
                  party or to take steps at your request before entering into
                  such a contract.
                  <br></br>
                  Comply with a legal obligation means processing your personal
                  data where it is necessary for compliance with a legal
                  obligation that we are subject to.
                </div>
                <div className='content-boldText'>THIRD PARTIES </div>
                <div className='content-boldText'>EXTERNAL THIRD PARTIES </div>
                <div className='content-normalText mt-l'>
                  <CircleIcon
                    className='circleIcon'
                    sx={{ fontSize: '.3rem' }}
                  />
                  Service providers who provide IT and system administration
                  services.
                </div>
                <div className='content-normalText mt-l'>
                  <CircleIcon
                    className='circleIcon'
                    sx={{ fontSize: '.3rem' }}
                  />
                  Professional advisers acting as processors or joint
                  controllers including lawyers, bankers, auditors and insurers
                  who provide consultancy, banking, legal, insurance and
                  accounting services.
                </div>
                <div className='content-normalText mt-l'>
                  <CircleIcon
                    className='circleIcon'
                    sx={{ fontSize: '.3rem' }}
                  />
                  Federal and State Inland Revenue Services, regulators and
                  other authorities acting as processors or joint controllers
                  who require reporting of processing activities in certain
                  circumstances.
                </div>
                <div className='content-boldText'>YOUR LEGAL RIGHTS</div>
                <div className='content-normalText'>You have the right to:</div>
                <div className='content-normalText mt-s'>
                  Request access to your personal data (commonly known as a
                  “data subject access request”). This enables you to receive a
                  copy of the personal data we hold about you and to check that
                  we are lawfully processing it.
                </div>
                <div className='content-normalText mt-s'>
                  Request correction of the personal data that we hold about
                  you. This enables you to have any incomplete or inaccurate
                  data we hold about you corrected, though we may need to verify
                  the accuracy of the new data you provide to us.
                </div>
                <div className='content-normalText mt-s'>
                  Request erasure of your personal data. This enables you to ask
                  us to delete or remove personal data where there is no good
                  reason for us continuing to process it. You also have the
                  right to ask us to delete or remove your personal data where
                  you have successfully exercised your right to object to
                  processing (see below), where we may have processed your
                  information unlawfully or where we are required to erase your
                  personal data to comply with local law. Note, however, that we
                  may not always be able to comply with your request of erasure
                  for specific legal reasons which will be notified to you, if
                  applicable, at the time of your request.
                </div>
                <div className='content-normalText mt-s'>
                  Object to processing of your personal data where we are
                  relying on a legitimate interest (or those of a third party)
                  and there is something about your particular situation which
                  makes you want to object to processing on this ground as you
                  feel it impacts on your fundamental rights and freedoms. You
                  also have the right to object where we are processing your
                  personal data for direct marketing purposes. In some cases, we
                  may demonstrate that we have compelling legitimate grounds to
                  process your information which override your rights and
                  freedoms.
                </div>
                <div className='content-normalText mt-s'>
                  Request restriction of processing of your personal data. This
                  enables you to ask us to suspend the processing of your
                  personal data in the following scenarios:
                </div>
                <div className='content-normalText mt-l'>
                  <CircleIcon
                    className='circleIcon'
                    sx={{ fontSize: '.3rem' }}
                  />
                  If you want us to establish the data’s accuracy.
                </div>
                <div className='content-normalText mt-l'>
                  <CircleIcon
                    className='circleIcon'
                    sx={{ fontSize: '.3rem' }}
                  />
                  Where our use of the data is unlawful but you do not want us
                  to erase it.
                </div>
                <div className='content-normalText mt-l'>
                  <CircleIcon
                    className='circleIcon'
                    sx={{ fontSize: '.3rem' }}
                  />
                  Where you need us to hold the data even if we no longer
                  require it as you need it to establish, exercise or defend
                  legal claims.
                </div>
                <div className='content-normalText mt-l'>
                  <CircleIcon
                    className='circleIcon'
                    sx={{ fontSize: '.3rem' }}
                  />
                  You have objected to our use of your data but we need to
                  verify whether we have overriding legitimate grounds to use
                  it.
                </div>
                <div className='content-normalText mt-s'>
                  Request the transfer of your personal data to you or to a
                  third party. We will provide to you, or a third party you have
                  chosen, your personal data in a structured, commonly used,
                  machine-readable format. Note that this right only applies to
                  automated information which you initially provided consent for
                  us to use or where we used the information to perform a
                  contract with you.
                </div>
                <div className='content-normalText mt-s'>
                  {' '}
                  Withdraw consent at any time where we are relying on consent
                  to process your personal data. However, this will not affect
                  the lawfulness of any processing carried out before you
                  withdraw your consent. If you withdraw your consent, we may
                  not be able to provide certain products or services to you. We
                  will advise you if this is the case at the time you withdraw
                  your consent.
                </div>
              </Fade>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Policy;
